import { render, staticRenderFns } from "./ServiceProvidersFilter.vue?vue&type=template&id=8467e3fa&"
import script from "./ServiceProvidersFilter.vue?vue&type=script&lang=ts&"
export * from "./ServiceProvidersFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports